export default class MobileAppChecker {

  static isMobileApp() {
    if (window.ReactNativeWebView) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/mobile_app_checker.js